module.exports = __webpack_public_path__ + "static/media/IconSuccessful.556e1e67.svg";